import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
const PressDeleteEndpoint = ApiEndpoints.adminPress.PressDelete;
const PressListEndpoint = ApiEndpoints.adminPress.PressList;
const blogEditPath = "edit-press";
const tableHeader = ["Date", "Title", "Category", "Slug"];
const tbody = ["date", "title", "slug"];

export default function PressListing() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", PressListEndpoint);
      const result = response.pressReleases;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (pressrelease_id) => {
    const payload = { pressrelease_id };
    try {
      const response = await ApiRequest("POST", PressDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'press Management',
    user: 'Admin',
    innerpage: 'Press Management / Press'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-press">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={blogEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
